import { useEffect, useState } from "react"
import { StyledDatePicker } from "./styled"
import dayjs, { Dayjs } from "dayjs"
import utc from "dayjs/plugin/utc"
import timeZone from "dayjs/plugin/timezone"
import MonthSelection from "./MonthSelection"
import YearSelection from "./YearSelection"
import DateSelection from "./DateSelection"

dayjs.extend(utc)
dayjs.extend(timeZone)

interface IDatePickerProps {
  value?: Dayjs
  onChange?: (day: Dayjs) => void
}

enum IDisplaySection {
  SELECT_DATE = "SELECT_DATE",
  SELECT_MONTH = "SELECT_MONTH",
  SELECT_YEAR = "SELECT_YEAR",
}

const BirthDatePicker = (props: IDatePickerProps) => {
  const { value, onChange } = props

  const [section, setSection] = useState(IDisplaySection.SELECT_DATE)
  const [month, setMonth] = useState(value ?? dayjs().startOf("month"))

  useEffect(() => {
    if (value && value.month() !== month.month()) {
      setMonth(value.startOf("month"))
    }
  }, [value])

  const onSelectMonth = (month: Dayjs) => {
    setMonth(month)
    setSection(IDisplaySection.SELECT_DATE)
  }

  const onSelectYear = (month: Dayjs) => {
    setMonth(month)
    setSection(IDisplaySection.SELECT_MONTH)
  }

  return (
    <StyledDatePicker>
      {section === IDisplaySection.SELECT_DATE && (
        <DateSelection
          value={value}
          onChange={onChange}
          month={month}
          setMonth={setMonth}
          setSection={setSection}
        />
      )}

      {section === IDisplaySection.SELECT_MONTH && (
        <MonthSelection
          value={value}
          month={month}
          onSelectMonth={onSelectMonth}
          setMonth={setMonth}
        />
      )}

      {section === IDisplaySection.SELECT_YEAR && (
        <YearSelection
          value={value}
          month={month}
          onSelectYear={onSelectYear}
          setMonth={setMonth}
        />
      )}
    </StyledDatePicker>
  )
}

export default BirthDatePicker
